module.exports = vendor_highcharts_lib;